import { SectionNotification, SectionNotificationType, TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { useConfig } from '../../contexts/config-context';
import { useFieldActions } from '../../contexts/field-actions-context';
import { useTranslation } from '../../contexts/translation-context';
import { classes } from './login-bar.st.css';
export const LoginBarFieldWUT = _ref => {
  let {
    FieldLayout,
    id
  } = _ref;
  const {
    userData,
    language
  } = useConfig();
  const {
    actions
  } = useFieldActions();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(SectionNotification, {
    size: "regular",
    type: SectionNotificationType.wired,
    className: classes.loginBar
  }, userData ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionNotification.Text, null, t('form.login-bar.title.logged-in-state', {
    user: userData == null ? void 0 : userData.email
  })), /*#__PURE__*/React.createElement(TextButton, {
    priority: TextButtonPriority.link,
    className: classes.loginBarButton,
    onClick: () => actions == null ? void 0 : actions.requestLogout()
  }, t('form.login-bar.action.logout'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionNotification.Text, null, t('form.login-bar.title.logged-out-state'), /*#__PURE__*/React.createElement(TextButton, {
    className: classes.loginBarButton,
    onClick: () => actions == null ? void 0 : actions.requestLogin(language)
  }, t('form.login-bar.actions.login'))))));
};
//# sourceMappingURL=login-bar.js.map